export const StorageTypes = {
  IStorageService: Symbol("IStorageService"),
};
